module.exports = {
  "scale": {
    "scaleType": "量表类型",
    "questionsNumber": "共{0}题",
    "scaleDescription": "量表说明",
    "scaleIntroduction": "量表简介",
    "startEvaluation": "开始测评",
    "evaluation": "测评",
    "schedule": "进度",
    "submitErrorHint": "还有{0}道必填题目未完成，请完成后再提交",
    "submitHint": "测评提交成功",
    "scaleErrorHint": "当前测评的状态已经不可以填写"
  },
}



// WEBPACK FOOTER //
// ./src/i18n/scale/en.js